import { createAction, props } from '@ngrx/store';

export const routineList = createAction('ROUTINE_LIST', props<{items: any}>());
export const routineCreate = createAction('ROUTINE_CREATE', props<{item: any}>());
export const routineUpdate = createAction('ROUTINE_UPDATE', props<{item: any}>());
export const routineDelete = createAction('ROUTINE_DELETE', props<{item: any}>());
